import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ReferralStatsCardsProps {
  totalReferrals: number;
  completedReferrals: number;
  pendingReferrals: number;
  remainingReferrals: number;
}

const ReferralStatsCards: React.FC<ReferralStatsCardsProps> = ({
  totalReferrals,
  completedReferrals,
  pendingReferrals,
  remainingReferrals,
}) => {
  const { t } = useTranslation();

  const stats = [
    {
      value: totalReferrals,
      label: t("profile.referral.totalReferrals"),
      color: "#2563eb",
      bg: "#eff6ff",
    },
    {
      value: completedReferrals,
      label: t("profile.referral.completedReferrals"),
      color: "#16a34a",
      bg: "#f0fdf4",
    },
    {
      value: pendingReferrals,
      label: t("profile.referral.pendingReferrals"),
      color: "#d97706",
      bg: "#fffbeb",
    },
    {
      value: remainingReferrals,
      label: t("profile.referral.remainingReferrals"),
      color: "#7c3aed",
      bg: "#f5f3ff",
    },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat) => (
        <Grid item xs={6} sm={3} key={stat.label}>
          <Card
            elevation={1}
            sx={{
              borderRadius: 2,
              backgroundColor: stat.bg,
              border: `1px solid ${stat.color}22`,
              textAlign: "center",
            }}
          >
            <CardContent sx={{ py: 2, px: 1, "&:last-child": { pb: 2 } }}>
              <Typography
                variant="h4"
                fontWeight={700}
                sx={{ color: stat.color, lineHeight: 1.2 }}
              >
                {stat.value}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#6b7280",
                  fontWeight: 500,
                  display: "block",
                  mt: 0.5,
                  lineHeight: 1.3,
                }}
              >
                {stat.label}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ReferralStatsCards;
